import hubspotChatService from '../lib/services/hubspotChatService'
import { useCurrentCompany } from './useCurrentCompany'
import { useCurrentUser } from './useCurrentUser'

export function useHubspotChat() {
  const currentUser = useCurrentUser()
  const currentCompany = useCurrentCompany()

  return {
    openChat: () =>
      hubspotChatService.openChat({
        currentUser,
        currentCompany,
      }),
  }
}
